import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';
import moment from 'moment';

const useMasterRate = (year: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [rateList, setRateList] = useState<MasterRateItemDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.master.setup.rate.list, year],
    () =>
      fetcher.master.postMasterRateList({
        group_id: year,
      }),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setRateList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: rateSave } = useMutation(
    [endpoints.master.setup.rate.save ],
    fetcher.master.postMasterRateSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, rateList, refetch, rateSave  };
};

export default useMasterRate;
